import { config } from '../../../core/config/config';
import { TReport } from '../definitions';

export const getReport = async (token: string, report_id: string): Promise<TReport> => {
  try {
    const uri = `${config.uri.lp_backend}/reports/analytics/${report_id}`;
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
